import { IconPlus, IconUsers } from "@tabler/icons-react";
import styles from "./ClientActivitySummary.module.css";
import Button from "../../components/UI/Button/button";
import { Link } from "react-router-dom";

export default function WelcomeBanner({ companyName }) {
  return (
    <div className={styles.welcome}>
      <div className={styles.welcomeText}>
        <div className={styles.welcomeGreeting}>Welcome back</div>
        <div className={styles.welcomeTitle}>
          Good to see you {companyName}!
        </div>
        <div className={styles.welcomeSub}>
          Here's what's happening with your recruitment activity today.
        </div>
      </div>
      <div className={styles.welcomeActions}>
        <Button
          as={Link}
          to="/add-new-job/job"
          variant="primary"
          className="py-2 min-h-10"
          leftIcon={<IconPlus size={15} />}
        >
          Post a Job/Gig
        </Button>
        <Button
          as={Link}
          to="/talent"
          variant="glass"
          className="py-2 min-h-10"
          leftIcon={<IconUsers size={15} />}
        >
          Browse Talent
        </Button>
      </div>
    </div>
  );
}
